import { render } from "./BannerProfilePanel.vue?vue&type=template&id=5ebefda9&scoped=true"
import script from "./BannerProfilePanel.vue?vue&type=script&lang=js"
export * from "./BannerProfilePanel.vue?vue&type=script&lang=js"

import "./BannerProfilePanel.vue?vue&type=style&index=0&id=5ebefda9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebefda9"]])

export default __exports__